import { create } from "zustand";

export const AITrackerStore = create((set) => ({
  customer_plan: [],

  //AI tracker
  improved: [],
  declined: [],
  ShowDialogTracker: false,
  AITracker_project: [],
  AITracker_name: null,
  mapshowloader: false,
  mapkeywordlimit: 10,
  mapProjectlimit: 2,
  mapcompetitorslimit: 2,
  map_rank_group: [],
  mapactive_tab_rank: "",
  map_date: { title: "days", day: 30, meta_des: "30" },
  map_top_rank: {
    data: [],
    top_rank: false,
    type: "",
    competitors: false,
  },
  ISPROJECT: false,
  mapdeviceType: null,
  CURRLOCATION: {
    code: null,
    name: null,
  },
  map_deviceType: null,
  map_all_loc_data: [],
  map_keyword_latest_data: [],
  map_keyword_old_data: [],
  map_keyword_loc_data: "",

  selected_project_id: null,
  RANKMOVEDUP: 0,
  RANKMOVEDDOWN: 0,
  USERALLPENDINGRESULT: [],
  USERALLKEYWORDRESULT: [],
  KEYWORDMOVEDOWN: [],
  KEYWORDMOVEUP: [],
  RANKKEYWORD: [],
  SELECTEDPROJECTNEWDATA: [],
  USERCOMPATITORS: [],
  PREVIOUSALLOLDDATA: [],
  OLDKEYWORDDATA: [],
  USERCURRENTPROJECTLOCATION: [],

  country_Data: { data: [], error: false, loading: true },
  country_Language_Data: { data: [], error: false, loading: true },
  mapRankTableColumn: [],
  updateMapRankTableCol: (column) =>
    set((state) => {
      const itemExists = state.mapRankTableColumn.includes(column);
      return {
        mapRankTableColumn: itemExists
          ? state.mapRankTableColumn.filter((item) => item !== column)
          : [...state.mapRankTableColumn, column],
      };
    }),

  mapCompetitorTableColumn: [],
  updateMapCompetitorTableCol: (column) =>
    set((state) => {
      const itemExists = state.mapCompetitorTableColumn.includes(column);
      return {
        mapCompetitorTableColumn: itemExists
          ? state.mapCompetitorTableColumn.filter((item) => item !== column)
          : [...state.mapCompetitorTableColumn, column],
      };
    }),

  // project section
  project_section: {
    data: [],
    error: false,
    loading: true,
  },

  history_data: {
    data: [],
    error: true,
    loading: true,
  },

  userAccessData: [],

  //add project

  addProject: {
    open: false,
    type: "",
    step: 1,
    domainUrl: "",
    project_name: "",
    project_id: null,
    language: null,
    location: null,
    competitors: [],
    device_type: null,
    keyword: [],
    complete_steps: [],
    project_usage: { limits: [], loading: true, error: false },
  },

  // Actions
  setAddProjectField: (field, value) =>
    set((state) => ({
      addProject: {
        ...state.addProject,
        [field]: value,
      },
    })),

  setMultipleFields: (fields) =>
    set((state) => ({
      addProject: {
        ...state.addProject,
        ...fields,
      },
    })),

  resetAddProject: () =>
    set(() => ({
      addProject: {
        open: false,
        type: "",
        step: 1,
        domainUrl: "",
        project_name: "",
        project_id: null,
        language: null,
        location: null,
        competitors: [],
        device_type: null,
        keyword: [],
        complete_steps: [],
        project_usage: { limits: [], loading: true, error: false },
      },
    })),

  pdfFormat: [],
}));
